class ListCollator {

  items = []
  sortedItems = []

  addItems = (items) => {
    this.items = [ ...this.items, ...items ];
  }

  sortByDate = () => {
    const sortedDates = [];
    const groupedDates = this._createDateGroups();
    const availableDates = Object.keys(groupedDates);

    availableDates.map(date => {
      const dateSchedules = groupedDates[date];
      
      sortedDates.push({
        date,
        isoDate: dateSchedules[0].isoDate, // WARN: Acoplamento
        status: dateSchedules[0].statusName, // WARN: Acoplamento
        schedules: dateSchedules,
      });

      return date;
    });
    
    this.sortedItems = sortedDates;
  }

  _createDateGroups = () => {
    return this.items.reduce(
      (groupedItems, currentItem) => {
        const date = currentItem.date;

        if (!groupedItems[date]) {
          groupedItems[date] = [];
        }
        groupedItems[date].push(currentItem);
        
        return groupedItems;
      }, {}
    );
  }
}

export default ListCollator;